import React, { useEffect, useState } from 'react';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import { MAIN_STORE_ROUTE_KEYS } from 'utils/constants';
import FormStepper from 'components/base/form-stepper';
import AddConversionListDetails from './add-manage-meals-details';
import AddConversionListStoreItems from './add-manage-meals-store-items';
import useBrandChefsContext from 'contexts/brand-chefs.context';
import ReviewConversionListDetails from './review-manage-meals-details';
import { ENUM_UNIT } from 'models/common.model';
import { apiService } from 'services/base.service';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ConversionListFormType, IngredientType } from 'models/pricing.model';

export const DefaultconversionListFormData: ConversionListFormType = {
  name: '',
  secton_name: '',
  no_of_portions: '',
  portion_type: ENUM_UNIT.KG,

  ingredients: [{ ingredient_name: '', quantity: '', type: 'meal-item' }],
  packaging: [{ ingredient_name: '', quantity: '', type: 'packaging' }]
};

const AddConversionList = () => {
  const { setIsBackLink, setBackLinkTitle, setBackLink } = useDashboardContext();
  const [isCreatingVendors, setIsCreatingVendors] = useState(false);
  const {
    conversionListFormData,
    step,
    setStep,
    setConversionListFormData,
    selectedConversionItem,
    setSelectedConversionItem
  } = useBrandChefsContext();

  const router = useNavigate();

  function isStepEmpty(data: any): boolean {
    for (const item of data) {
      for (const key in item) {
        if (
          typeof item[key] === 'string' &&
          item[key] === '' &&
          key !== 'portion_type' &&
          key !== 'no_of_portions'
        ) {
          return true;
        }
      }
    }
    return false;
  }

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to vendors');
    setBackLink(MAIN_STORE_ROUTE_KEYS.VENDORS);
    return () => {
      setIsBackLink(false);
    };
  }, []);

  const createVendor = async () => {
    const data = {
      items: conversionListFormData?.map((vendorDataToUpload) => {
        return {
          name: vendorDataToUpload?.name,
          secton_name: vendorDataToUpload?.secton_name,
          no_of_portions: Number(vendorDataToUpload?.no_of_portions),
          portion_type: vendorDataToUpload?.portion_type,
          ingredients: vendorDataToUpload?.ingredients?.map((_) => {
            return {
              ..._,
              quantity: Number(_.quantity)
            };
          })
        };
      })
    };
    try {
      setIsCreatingVendors(true);
      const res = await apiService.post('ingredient-mix/cokitchen/create-mixes', { data });
      if (res) {
        router(MAIN_STORE_ROUTE_KEYS.MANAGE_MEALS);
        setConversionListFormData([DefaultconversionListFormData]);
        toast(<ToastMessage message='conversion list item created successfully' type='success' />);
      }
    } catch (err: any) {
      toast(
        <ToastMessage
          message={err.response.data.message || 'Error creating conversion list item'}
          type='error'
        />
      );
    } finally {
      setIsCreatingVendors(false);
    }
  };

  return (
    <div>
      <PageHeaderText
        title='Add manually'
        description='Add new items with their ingredient breakdown to the conversion list'
      />
      <div className='max-w-[678px]'>
        <FormStepper
          disabled={
            step === 1
              ? isStepEmpty(conversionListFormData)
              : isStepEmpty(
                  conversionListFormData.reduce(
                    (data: IngredientType[], item) => data.concat(item.ingredients),
                    []
                  )
                )
          }
          title=''
          step={step}
          handleConfirmClick={() => createVendor()}
          setStep={setStep}
          onNextClick={() => {
            if (selectedConversionItem) return;
            setSelectedConversionItem({
              ...conversionListFormData[0],
              itemIndex: 0
            });
          }}
          noOfSteps={3}
          loading={isCreatingVendors}>
          <div>
            {step === 1 ? (
              <AddConversionListDetails />
            ) : step === 2 ? (
              <AddConversionListStoreItems />
            ) : (
              <ReviewConversionListDetails />
            )}
          </div>
        </FormStepper>
      </div>
    </div>
  );
};

export default AddConversionList;
